var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus3({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 2.5C10.355 2.5 10.6429 2.78782 10.6429 3.14286V9.35714H16.8571C17.2122 9.35714 17.5 9.64496 17.5 10C17.5 10.355 17.2122 10.6429 16.8571 10.6429H10.6429V16.8571C10.6429 17.2122 10.355 17.5 10 17.5C9.64496 17.5 9.35714 17.2122 9.35714 16.8571V10.6429H3.14286C2.78782 10.6429 2.5 10.355 2.5 10C2.5 9.64496 2.78782 9.35714 3.14286 9.35714H9.35714V3.14286C9.35714 2.78782 9.64496 2.5 10 2.5Z",
    fill: "#D53E20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus3);
export default __webpack_public_path__ + "static/media/plus-3.78f149b39bfbfe0a2da8c06ff5f8d9b3.svg";
export { ForwardRef as ReactComponent };